import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { TourEntryDetails } from './TourEntryDetails';
import type { GalleryImage, TourEntry } from '../../types/showcase';
interface InteractiveTourMapProps {
  map: GalleryImage;
  entries: TourEntry[];
  activeNumber: number | null;
  selectedNumber: number | null;
  onHover: (n: number | null) => void;
  onSelect: (n: number | null) => void;
}
export function InteractiveTourMap({
  map,
  entries,
  activeNumber,
  selectedNumber,
  onHover,
  onSelect
}: InteractiveTourMapProps) {
  const leaveTimer = useRef<number>();
  const enter = (n: number) => {
    window.clearTimeout(leaveTimer.current);
    onHover(n);
  };
  const leave = () => {
    window.clearTimeout(leaveTimer.current);
    leaveTimer.current = window.setTimeout(() => onHover(null), 140);
  };
  useEffect(() => () => window.clearTimeout(leaveTimer.current), []);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onSelect(null);
        onHover(null);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onSelect, onHover]);
  return <div className="relative w-full select-none" onClick={() => onSelect(null)} data-id="element-166" data-mp="3tu2q55egpm32">
      <img src={map.src} alt={map.alt} className="block h-auto w-full" draggable={false} data-id="element-167" data-mp="3ow188nsrvst6" />

      {entries.map(entry => {
      const isActive = activeNumber === entry.number;
      const isSelected = selectedNumber === entry.number;
      const openLeft = entry.x > 55;
      const vertical = entry.y > 70 ? 'bottom-0' : entry.y < 30 ? 'top-0' : 'top-1/2 -translate-y-1/2';
      return <div key={entry.number} className={`absolute aspect-square w-[2.8%] -translate-x-1/2 -translate-y-1/2 ${isActive ? 'z-30' : 'z-10'}`} style={{
        left: `${entry.x}%`,
        top: `${entry.y}%`
      }} onMouseEnter={() => enter(entry.number)} onMouseLeave={leave} data-id="element-168" data-mp="364qii9ys9m2v">
            <button type="button" aria-label={`${entry.number}: ${entry.model} by ${entry.builder}`} aria-expanded={isActive} onClick={e => {
          e.stopPropagation();
          onSelect(isSelected ? null : entry.number);
        }} onFocus={() => enter(entry.number)} onBlur={leave} className={`absolute inset-[-25%] rounded-full transition-[box-shadow,background-color] duration-150 focus-visible:outline-none ${isActive ? 'bg-navy/15 ring-[3px] ring-navy' : 'hover:bg-navy/10 focus-visible:ring-[3px] focus-visible:ring-navy'}`} data-id="element-169" data-mp="hdpnd5nosdmk" />

            <AnimatePresence data-id="element-170" data-mp="cg7jvusfuqly">
              {isActive && <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.96
          }} transition={{
            duration: 0.15,
            ease: [0.23, 1, 0.32, 1]
          }} className={`absolute hidden w-72 md:block ${openLeft ? 'right-full pr-3' : 'left-full pl-3'} ${vertical}`} style={{
            transformOrigin: openLeft ? 'right center' : 'left center'
          }} onClick={e => e.stopPropagation()} data-id="element-171" data-mp="1jrerr0aa20ib">
                  <div className="rounded-xl border border-line bg-white p-4 shadow-2xl" data-id="element-172" data-mp="2uiuwubsojx9n">
                    <TourEntryDetails entry={entry} data-id="element-173" data-mp="2pji45af4nvz5" />
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}